// src/components/Achievements.js
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography
} from '@mui/material';
// import { useNavigate } from 'react-router-dom'; //Non serve più

// Import delle icone da Material-UI Icons
import StarIcon from '@mui/icons-material/Star';
import CategoryIcon from '@mui/icons-material/Category';
import SearchIcon from '@mui/icons-material/Search';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import TodayIcon from '@mui/icons-material/Today';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SavingsIcon from '@mui/icons-material/Savings';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AssignmentIcon from '@mui/icons-material/Assignment';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
// import { achievementData } from './achievementsData'; //NON serve più

// Mappa le stringhe degli icon con i componenti corrispondenti
const iconMap = {
  Star: StarIcon,
  Category: CategoryIcon,
  Search: SearchIcon,
  TrendingUp: TrendingUpIcon,
  ThumbUp: ThumbUpIcon,
  EmojiEvents: EmojiEventsIcon,
  Today: TodayIcon,
  CalendarToday: CalendarTodayIcon,
  EventNote: EventNoteIcon,
  ShoppingCart: ShoppingCartIcon,
  TrendingDown: TrendingDownIcon,
  AttachMoney: AttachMoneyIcon,
  Savings: SavingsIcon,
  DeleteForever: DeleteForeverIcon,
  Restaurant: RestaurantIcon,
  ErrorOutline: ErrorOutlineIcon,
  Assignment: AssignmentIcon,
  LocalGroceryStore: LocalGroceryStoreIcon
};

// Array degli achievement (modifica secondo le tue necessità)
const achievementData = [
    { title: "Bonus Achievement", description: "Achievement speciale sbloccato!", criteria: { bonus: true }, icon: "Star" },
    { title: "Category Collector", description: "Hai usato 5 categorie differenti!", criteria: { minCategories: 5 }, icon: "Category" },
    { title: "Spending Sleuth", description: "Hai individuato ed eliminato una spesa ricorrente superflua!", criteria: { expenseElimination: true }, icon: "DeleteForever" },
    { title: "Spending Optimizer", description: "Hai raggiunto il giusto equilibrio tra spesa e risparmio!", criteria: { optimalRatio: true }, icon: "TrendingUp" },
    { title: "Budget Beginner", description: "Hai impostato il tuo primo budget!", criteria: { budgetSet: true }, icon: "AttachMoney" },
    { title: "Expense Rookie", description: "Hai registrato la tua prima spesa!", criteria: { minExpenses: 1 }, icon: "EmojiEvents" },
    { title: "Expense Novice", description: "Hai registrato 10 spese!", criteria: { minExpenses: 10 }, icon: "EmojiEvents" },
    { title: "Weekly Warrior", description: "Hai registrato spese per 7 giorni consecutivi!", criteria: { weeklyStreak: 7 }, icon: "Today" },
    { title: "Monthly Maven", description: "Sei rimasto sotto budget per un intero mese!", criteria: { underBudgetMonths: 1 }, icon: "ThumbUp" },
    { title: "Thrifty Tracker", description: "Hai registrato spese ogni giorno per 30 giorni consecutivi!", criteria: { dailyStreak: 30 }, icon: "CalendarToday" },
    { title: "Yearly Yoda", description: "Hai fatto una revisione completa delle spese per un anno!", criteria: { yearlyReview: true }, icon: "EventNote" },
    { title: "Shopping Strategist", description: "Hai evitato acquisti impulsivi per 30 giorni!", criteria: { shoppingStreak: 30 }, icon: "ShoppingCart" },
    { title: "Frugal Fighter", description: "Hai ridotto le spese del 10% rispetto al mese precedente!", criteria: { spendingReduction: 10 }, icon: "TrendingDown" },
    { title: "Weekly Saver", description: "Hai speso meno del 50% del budget settimanale!", criteria: { weeklySavings: 50 }, icon: "Savings" },
    { title: "Monthly Saver", description: "Hai speso meno del 50% del budget mensile!", criteria: { monthlySavings: 50 }, icon: "Savings" },
    { title: "Daily Tracker", description: "Hai registrato una spesa ogni giorno per una settimana!", criteria: { dailyStreak: 7 }, icon: "CalendarToday" },
    { title: "Expense Eliminator", description: "Hai individuato ed eliminato una spesa ricorrente!", criteria: { expenseElimination: true }, icon: "DeleteForever" },
    { title: "Restaurant Reviewer", description: "Hai registrato 10 uscite al ristorante!", criteria: { diningLogged: 10 }, icon: "Restaurant" },
    { title: "Budget Buster", description: "Hai superato il tuo budget del 20% in un mese (per imparare dai tuoi errori)!", criteria: { exceededBudget: 20 }, icon: "ErrorOutline" },
    { title: "Loyal Logger", description: "Hai registrato spese costantemente per 6 mesi!", criteria: { consistentLogging: 6 }, icon: "CalendarToday" },
    { title: "Expense Examiner", description: "Hai analizzato e categorizzato le spese per un intero mese!", criteria: { detailedAnalysis: true }, icon: "Assignment" },
    { title: "Grocery Guru", description: "Hai registrato tutte le spese alimentari per un mese!", criteria: { groceryTracking: true }, icon: "LocalGroceryStore" },
    { title: "Expense Pro", description: "Hai registrato 100 spese!", criteria: { minExpenses: 100 }, icon: "EmojiEvents" },
  ];

const Achievements = ({ open, onClose, unlockedAchievements = [] }) => { //unlockedAchievements non usato, ma lo lascio per coerenza
  // const navigate = useNavigate(); Non serve

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 'bold' }}>I Tuoi Achievement</DialogTitle>
      <DialogContent dividers>
        {achievementData.length === 0 ? (
          <Typography variant="body1">Nessun achievement definito.</Typography>
        ) : (
          <List>
            {achievementData.map((achievement, index) => {
              const IconComponent = iconMap[achievement.icon];
              // L'achievement è sbloccato solo se il titolo è presente nell'array unlockedAchievements
              const isUnlocked = unlockedAchievements.includes(achievement.title);
              return (
                <React.Fragment key={index}>
                  <ListItem>
                    <ListItemIcon>
                      {IconComponent ? (
                        <IconComponent sx={ isUnlocked ? {} : { filter: 'grayscale(100%)' } } />
                      ) : (
                        <span>{achievement.icon}</span>
                      )}
                    </ListItemIcon>
                    <ListItemText
                      primary={isUnlocked ? achievement.title : "Non ancora sbloccato"}
                      secondary={isUnlocked ? achievement.description : ""}
                    />
                  </ListItem>
                  {index < achievementData.length - 1 && <Divider />}
                </React.Fragment>
              );
            })}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose} //Semplificato
        >
          Torna alla Dashboard
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Achievements;